import React from 'react';
import { Ban } from 'lucide-react';
import { Button } from '../../ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip';
import { cn } from '../../../lib/utils';

// CommentCell: the comment cut to two lines; hovering (or focusing) it shows the whole comment.
export function CommentCell({ comment }) {
  const clamped = 'line-clamp-2 whitespace-pre-line break-words text-left text-xs font-medium text-ink-dim';
  if (!comment) return <div className={clamped}>—</div>;
  return (
    <Tooltip delayDuration={150}>
      <TooltipTrigger asChild>
        <div className={cn(clamped, 'cursor-help')} tabIndex={0}>{comment}</div>
      </TooltipTrigger>
      <TooltipContent side="left" align="start" className="max-w-md whitespace-pre-line break-words text-xs leading-relaxed">
        {comment}
      </TooltipContent>
    </Tooltip>
  );
}

// CancelCell: Cancel on a pending bonus, asking once before it is cancelled.
export function CancelCell({ view, confirming, cancelling, onAsk, onCancel, onKeep }) {
  if (!view.canCancel) return null;
  if (!confirming) {
    return (
      <Button variant="ghost" size="sm" className="gap-1.5 text-negative hover:text-negative" onClick={onAsk}>
        <Ban className="h-3.5 w-3.5" /> Cancel
      </Button>
    );
  }
  return (
    <div className="flex items-center gap-1.5">
      <Button size="sm" className="bg-negative text-white hover:bg-negative/90" disabled={cancelling} onClick={onCancel}>
        {cancelling ? 'Cancelling…' : 'Yes, cancel'}
      </Button>
      <Button variant="ghost" size="sm" onClick={onKeep}>Keep</Button>
    </div>
  );
}
